/**
 * As of 11/19/2021, the only change necessitating the copy/paste of this module from autobahn core is due to the fact that
 * this client's header on mobile still includes the search section, therefore was causing the minicart to open on mobile
 * We needed to update the selector that checks if the minicart should open to use the .header-account-container instead
 */

'use strict';

var SiteConstants = require('constants/SiteConstants');
var updateMiniCart = true;

function setMiniCartBodyMaxHeight(minicart) {
    var $minicart = $(minicart);
    var $minicartScrollable = $minicart.find('.product-summary');
    var minicartHeight = $minicart.outerHeight();
    var minicartScrollableHeight = $minicartScrollable.outerHeight();
    var minicartNonScrollableHeight = minicartHeight - minicartScrollableHeight;
    var minicartOffset = $minicart.offset().top - $(window).scrollTop();
    var subtractHeight = minicartOffset + minicartNonScrollableHeight;

    $minicartScrollable.css('max-height', 'calc(100vh - ' + subtractHeight + 'px)');
}

module.exports = function () {
    // The bonus chooser's close button sits under the header cart icon, so the pointer is already
    // over the mini cart trigger when the modal disappears. Hold hover until the pointer leaves.
    var hoverArmed = true;
    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', () => {
        hoverArmed = false;
    });
    $('.minicart').on('mouseleave', () => {
        hoverArmed = true;
    });

    $('.minicart').on('count:update', (event, count) => {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin touchstart', (event) => {
        var isEnhancedAddToCartMessageShown = $('#addedToCartModal').hasClass('show');
        if (window.isMobile() || isEnhancedAddToCartMessageShown || $('.data-checkout-stage').length > 0) {
            return;
        }
        if (event.type === 'mouseenter' && !hoverArmed) {
            return;
        }

        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('.minicart .popover').addClass('show');
                $('.popover-overlay').addClass('show');
                return;
            }

            $('.minicart .popover').addClass('show');
            $('.popover-overlay').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, data => {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;
                $.spinner().stop();
                $('body').trigger('minicart:loaded', $('.minicart .popover'));
                $('.minicart .btn-num-items').text(count);
            });
        }
    });

    $('body, .popover-overlay, .close-minicart').on('touchstart click', event => {
        if ($('.minicart').has(event.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
            $('.popover-overlay').removeClass('show');
        }
    });

    $('.minicart').on('click focusout', event => {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
        || (event.type === 'click' && $(event.target).is('.minicart .quantity'))
        || (event.type === 'click' && $(event.target).parents('.quantity-stepper').length > 0)
            || $('body').is('.modal-open:not(.show-header-search-modal)')) {
            event.stopPropagation();
            return;
        }
        $('.minicart .popover').removeClass('show');
        $('.popover-overlay').removeClass('show');
    });

    $('body').on('change', '.minicart .quantity', event => {
        if ($(event.target).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('body').on('product:afterAddToCart cart:update', () => {
        updateMiniCart = true;
    });

    $('body').on('minicart:loaded', (event, minicart) => {
        setMiniCartBodyMaxHeight(minicart);
    });
};
